import { Component, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Subscriber } from '../../../../shared/lib/helpers/subscriber';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/index';
import { UtilsService } from '../../../services/api/utils.service';
import { SoledadUserService } from '../../../../shared/services/b2b/user.service';
import { isEmptyObject, isUndefined } from '../../../../shared/lib/helpers/utils';
import { detectChangesOnFinalize } from '../../custom-rxjs-operators/detect-changes-on-finalize.operator';
import { User } from '../../../../shared/models/b2b/user';

// NgRx
import { ModalsService } from '../../../../shared/services/utils/modals.service';
import { EventsService } from '../../../../../app/shared/services/utils/events.service';
import { ToastData, ToastDataHelper } from '../../../../../app/shared/models/b2b/toastData';

@Component({
    selector: 'app-item-bill-list',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './item-bill-list.component.html'
})
export class ItemBillListComponent extends Subscriber implements OnInit {
    @Input() item: any = {};
    loading: boolean;
    user: User;

    constructor(
        private store: Store<AppState>,
        private utilsService: UtilsService,
        private usersService: SoledadUserService,
        private eventsService: EventsService,
        private translatesService: TranslateService,
        private modalsService: ModalsService,
        private cdr: ChangeDetectorRef
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscribeUserData();
    }

    subscribeUserData(): void {
        this.addSubscription(
            this.store
                .select((state) => state.user.data)
                .subscribe((user) => {
                    // console.log({user});
                    if (user) {
                        this.user = user;
                        this.cdr.detectChanges();
                    }
                })
        );
    }

    clickDownloadBill(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        this.subscribePDF();
        // this.utilsService.downloadPDF(this.item.URL_PDF);
    }

    clickPrintBill(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        this.utilsService.printPdf(this.item.URL_PDF);
    }

    isComercial(tipo: string): boolean {
        return tipo === 'COMERCIAL';
    }

    subscribePDF() {
        this.loading = true;
        this.usersService
            .billPrint(this.item.serie, this.item.numero, this.item.fechaDate)
            .pipe(detectChangesOnFinalize(this.cdr))
            .subscribe(
                (data) => {
                    // console.log({data});
                    if (!isUndefined(data)) {
                        this.item.URL_PDF = data;
                        this.loading = false;
                        if (!this.utilsService.downloadPDF(this.item.URL_PDF)) {
                            this.addSubscription(
                                this.translatesService
                                    .get('error_popup_blocker_detected')
                                    .pipe(detectChangesOnFinalize(this.cdr))
                                    .subscribe((texto) => this.showToast(texto, false))
                            );
                        }
                    }
                },
                (error) => {
                    console.log('error');
                }
            );
    }

    showToast(msg: string, success: boolean) {
        const toastData: ToastData = ToastDataHelper.create({ type: success ? 'success' : 'error', text: msg });
        this.eventsService.broadcast('showToast', toastData);
    }

    clickNewIncidence(): void {
        this.modalsService.open('incidents-new', null, {
            typeIncident: 'Facturacion',
            user: this.user,
            itemId: this.item.numero.toString()
        });
    }
}
